<script>
import { authComputed, uiComputed, uiMethods } from '@state/helpers'

export default {
  data() {
    return {
      submenuVisible: false,
    }
  },

  computed: {
    ...authComputed,

    ...uiComputed,
  },

  mounted() {
    if (!this.isIphone) {
      window.addEventListener('resize', this.checkSidebar)
    }

    if (
      this.$route.fullPath.includes('/grafikas') &&
      this.currentUser.programs.toString() !== 'nv' &&
      this.currentUser.programs.toString() !== 'grupese'
    ) {
      this.submenuVisible = true
    }
  },

  methods: {
    ...uiMethods,

    onToggleSubmenuClick() {
      this.submenuVisible = !this.submenuVisible
    },
  },
}
</script>

<template>
  <div class="flex w-full flex-1 flex-col">
    <base-mobile-header />

    <div class="flex w-full flex-1">
      <div
        class="sidebar p-4 hide-on-print overflow-y-auto"
        :class="{ 'flex flex-col': sidebarExpanded, hidden: !sidebarExpanded }"
      >
        <div v-if="currentUser" class="py-8 text-center">
          <base-avatar
            :filename="currentUser.avatar_thumb"
            class="w-24 h-24 mx-auto border border-white"
          />
          <div class="mt-2 text-lg text-gray-100 font-semibold">
            {{ currentUser.first_name }}
            {{ currentUser.last_name }}
          </div>
          <div class="tex-sm text-gray-500">
            {{ currentUser.role | roleDisplay }}
          </div>
        </div>

        <div class="mt-8 pb-12 flex-grow">
          <router-link
            class="sidebar-link"
            :to="{ name: 'users' }"
            :active="$route.fullPath.includes('/savanoriai')"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'users']" class="mr-1" />
            </div>
            <span> Savanoriai </span>
          </router-link>
          <router-link
            v-if="currentUser.programs.toString() !== 'drauge'"
            class="sidebar-link"
            :to="{ name: 'availability' }"
            :active="$route.fullPath.includes('/galimybes')"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon
                :icon="['fas', 'calendar-plus']"
                class="mr-1"
              />
            </div>
            <span> Galimybės </span>
          </router-link>
          <router-link
            v-if="currentUser.programs.toString() === 'nv'"
            class="sidebar-link cursor-pointer"
            :to="{ name: 'kids' }"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'object-group']" class="mr-1" />
            </div>
            <span> Grafikas </span>
          </router-link>
          <router-link
            v-if="currentUser.programs.toString() === 'grupese'"
            class="sidebar-link cursor-pointer"
            :to="{ name: 'group-duties' }"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'object-group']" class="mr-1" />
            </div>
            <span> Grafikas </span>
          </router-link>
          <div
            v-if="
              currentUser.programs.toString() !== 'nv' &&
              currentUser.programs.toString() !== 'grupese' &&
              (currentUser.programs.toString().includes('kc') ||
                currentUser.programs.toString().includes('grupese'))
            "
            class="sidebar-link cursor-pointer"
            @click="onToggleSubmenuClick"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'object-group']" class="mr-1" />
            </div>
            <span> Grafikas </span>
          </div>
          <router-link
            v-if="
              currentUser.programs.toString().includes('nv') && submenuVisible
            "
            class="sidebar-link"
            :to="{ name: 'kids-hospital' }"
            :active="
              $route.fullPath.includes('/grafikas/ligonines') ||
              $route.fullPath === '/grafikas/sukurti'
            "
          >
            <div class="w-8 inline-block ml-8">
              <font-awesome-icon :icon="['fas', 'object-group']" class="mr-1" />
            </div>
            <span> Ligoninių grafikas </span>
          </router-link>
          <router-link
            v-if="
              currentUser.programs.toString().includes('grupese') &&
              submenuVisible
            "
            class="sidebar-link"
            :to="{ name: 'group-duties' }"
            :active="$route.fullPath.includes('/grafikas/budejimai-grupese')"
          >
            <div class="w-8 inline-block ml-8">
              <font-awesome-icon :icon="['fas', 'object-group']" class="mr-1" />
            </div>
            <span> Budėjimai grupėse </span>
          </router-link>
          <router-link
            v-if="
              currentUser.programs.toString().includes('kc') && submenuVisible
            "
            class="sidebar-link"
            :to="{ name: 'kids-kc' }"
            :active="
              $route.fullPath.includes('/grafikas/kc') ||
              $route.fullPath === '/grafikas/sukurti-istaiga'
            "
          >
            <div class="w-8 inline-block ml-8">
              <font-awesome-icon :icon="['fas', 'object-group']" class="mr-1" />
            </div>
            <span> KC grafikas </span>
          </router-link>
          <router-link
            class="sidebar-link"
            :to="{ name: 'documents' }"
            :active="$route.fullPath.includes('/dokumentai')"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'book']" class="mr-1" />
            </div>
            <span> Dokumentai </span>
          </router-link>
          <router-link
            class="sidebar-link"
            :to="{ name: 'calendar' }"
            :active="$route.fullPath.includes('/kalendorius')"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'calendar-alt']" class="mr-1" />
            </div>
            <span> Kalendorius </span>
          </router-link>
          <router-link
            class="sidebar-link"
            :to="{ name: 'statistic' }"
            :active="$route.fullPath.includes('/statistika')"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'chart-area']" class="mr-1" />
            </div>
            <span> Statistika </span>
          </router-link>
          <router-link
            class="sidebar-link"
            :to="{ name: 'profile' }"
            :active="$route.fullPath.includes('/profilis')"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'user-cog']" class="mr-1" />
            </div>
            <span> Mano paskyra </span>
          </router-link>
          <router-link
            class="sidebar-link"
            :to="{ name: 'logout' }"
            :active="$route.fullPath.includes('/atsijungti')"
          >
            <div class="w-8 inline-block">
              <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="mr-1" />
            </div>
            <span> Atsijungti </span>
          </router-link>
        </div>

        <div class="w-full mb-8 flex flex-col space-y-4 hidden">
          <div
            class="bg-white border border-gray-400 rounded-full p-1 flex align-items overflow-hidden flex-grow"
          >
            <div
              class="bg-red-400 border border-white border-1 rounded-l-full h-full text-xs text-white text-center p-1"
              style="width: 55%"
              >&nbsp;</div
            >
          </div>
          <div class="text-xs text-white text-center">
            Išbudėjote 45 val. ir tai yra mažesnis nei rekomenduotinas vidurkis
            – 55 val.
          </div>
        </div>
      </div>
      <div class="relative flex flex-grow min-w-full lg:min-w-0">
        <div class="body p-4 lg:p-8 bg-white">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
